//校验两位小数
export const validatePosNumber = (currNum) => {
  let rule = /^\d+(\.\d{0,2})?$/;
  let flag = true;
  if(!rule.test(currNum)){
    flag = false;
  }
  return flag;
}
// 0-9 整数
export const validateIntNumber = (currNum) => {
  let rule = /^[0-9]+$/ ;

  return rule.test(currNum);
}
// 0-9 加小数点
export const validateIntNumberSpot = (currNum) => {
  let rule = /^[+-]?((\d*(\.\d{1,})$)|(\d+$))/;

  return rule.test(currNum);
}

const MoneyTest = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;

// 金额添加千分位
export const comdify = function (n) {
    if(!n) return n;
    let str = n.split('.');
    let re = /\d{1,3}(?=(\d{3})+$)/g;
    let n1 = str[0].replace(re, "$&,");
    return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
};
//去除千分位中的‘，’
export const delcommafy = function (num){
    if(!num) return num;
    num = num.toString();
    num = num.replace(/,/gi, '');
    return num;
};
export const valdateFn = function (rule,val,cb) {
    setTimeout(() => {
        if(val) {
            let inputVal = delcommafy(val);
            if (rule.test(inputVal)) {
                cb()
            } else {
                cb('只能是数字金额,最多两位小数')
            }
        }
        cb()
    })
}
// 验证金额数字可以为负数
export const moneyValid = function (rule,val,cb) {
    valdateFn(/((^-?[1-9]\d*)|^-?0)(\.\d{0,2}){0,1}$/,val,cb);
};
// 验证金额数字不可以为负数
export const moneyNValid = function (rule,val,cb) {
    valdateFn(MoneyTest,val,cb);
};

// 获取输入框的值
export const getInputValue = function (el) {
    let inputVal = el.target.value || '';
    return comdify(delcommafy(inputVal));
};
//过滤掉商品名称含义指定字符方法
export const filterStr = (str)=>{
    var keyWordsArr = ['AEF','HY','MK','SNW','YC','YJT','A...','H...','M...','S...','Y...'];
    var result = '';
    for(let i = 0;i<keyWordsArr.length;i++){
        if(str.indexOf(keyWordsArr[i]) !== -1){
            result = str.replace(/\b(AEF|HY|MK|SNW|YC|YJT|M|A|H|S|Y)\b/g," ");
            result = result.charAt(result.length-1) === ' '?result.substring(0, result.lastIndexOf('-')):result;
            break;
        }else{
            result = str;
        }
    }
    return result;
};
